import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  // {
  //   path: '/index',
  //   name: 'IndexView',
  //   component: () => import("../views/IndexView"),
  // },
  // {
  //   path: '/',
  //   redirect: '/index'
  // },
  {
    path: '/index',
    name: 'IndexView',
    component: () => import("../views/homeView"),
  },
  {
    path: '/home',
    // name: 'index',
    component: () => import("../views/IndexView"),
  },
  {
    path: '/detela',
    name: 'Detela',
    component: () => import("../views/detela"),
  },
  {
    path: '/jactSub',
    name: 'JactSub',
    component: () => import("../views/JactSubmitView"),
  },
  {
    path: '/jactNot',
    name: 'JactNot',
    component: () => import("../views/JactNoticeView"),
  },
  {
    path: '/jactSuccess',
    name: 'JactSuccess',
    component: () => import("../views/JactSuccessView"),
  }
]

const router = new VueRouter({
  routes
})

export default router
